module.exports = __webpack_public_path__ + "img/tablet-neck-13_18x300.25efae94.png";